// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected-session {
  width: 80%;
  min-height: 100%;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  position: relative;
}

.selected-session-mobile {
  width: 100%;
}
.selected-session-hidden-mobile {
  display: none;
}

.header {
  height: 17%;
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.arrow-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.arrow-btn {
  background: transparent;
  border: none;
  cursor: pointer;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 14px;
}

.feedback-wrapper {
  display: flex;
  justify-content: space-between;
}

.patient-name {
  font-size: 16px;
  font-weight: 500;
  color: #111827;
}

.feedback-btn {
  width: max-content;
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #0d9488;
  color: white;
  border: none;
  border-radius: 10px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
}

.tab-section {
  width: 100%;
  height: 8%;
  max-height: 8%;
  position: relative;
  overflow: hidden;
}

.summary-transcript-view {
  width: 100%;
  height: 75%;
  position: relative;
}

@media (max-width: 1024px) {
  .selected-session {
    width: 75%;
    padding: 16px;
    padding-top: 5%;
  }
}

@media (max-width: 600px) {
  .selected-session {
    padding: 0px;
  }
  .header {
    padding: 20px 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboardComponent/SelectedSession.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,aAAa;IACb,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".selected-session {\r\n  width: 80%;\r\n  min-height: 100%;\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  position: relative;\r\n}\r\n\r\n.selected-session-mobile {\r\n  width: 100%;\r\n}\r\n.selected-session-hidden-mobile {\r\n  display: none;\r\n}\r\n\r\n.header {\r\n  height: 17%;\r\n  width: 100%;\r\n  padding: 24px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.arrow-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.arrow-btn {\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.page-title {\r\n  font-size: 20px;\r\n  font-weight: 600;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.feedback-wrapper {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.patient-name {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #111827;\r\n}\r\n\r\n.feedback-btn {\r\n  width: max-content;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  background-color: #0d9488;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 10px;\r\n  padding: 8px 16px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n.tab-section {\r\n  width: 100%;\r\n  height: 8%;\r\n  max-height: 8%;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.summary-transcript-view {\r\n  width: 100%;\r\n  height: 75%;\r\n  position: relative;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .selected-session {\r\n    width: 75%;\r\n    padding: 16px;\r\n    padding-top: 5%;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .selected-session {\r\n    padding: 0px;\r\n  }\r\n  .header {\r\n    padding: 20px 15px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
